// extracted by mini-css-extract-plugin
export default {"body__side-bar":"styles_body__side-bar__cWO2y","body__action-button":"styles_body__action-button__Ahyq4","body__action-button--primary":"styles_body__action-button--primary__durdT"};